export const FEATURE_TOGGLE_KEY_PREFIX = 'ww_ft_';
export const FEATURE_TOGGLE_KEY_PREFIX_V2 = `${FEATURE_TOGGLE_KEY_PREFIX}v2_`;

export enum AppBannerValues {
    small = 'small',
    smart = 'smart',
    none = 'none',
    micro = 'micro',
}

export enum p100AddToWishlistMobileVariant {
    control = 'control',
    variantA = 'variantA',
}

export enum p100SsrJsonEscapingExperimentVariant {
    latestsJsesc = 'latestsJsesc',
    latestsJsescAndCaching = 'latestsJsescAndCaching',
}

export enum p100FiltersRedesignVariant {
    control = 'control',
    externalSorting = 'externalSorting',
    rectangleFilters = 'rectangleFilters',
}

export enum binaryWithNoExperiment {
    control = 'control',
    treatment = 'treatment',
    noExperiment = 'no experiment',
}

export enum BinaryWithOffVariant {
    control = 'control',
    treatment = 'treatment',
    off = 'off',
}

export enum SimilarProductsSliderVariant {
    off = 'off',
    default = 'default',
    algolia = 'algolia',
}

export enum changeSmartAppBannerLink {
    android = 'android',
    ios = 'ios',
    all = 'all',
    none = 'none',
}

export enum SlowDownTestDelayMilliseconds {
    zeroSeconds = 'zeroSeconds',
    twoSeconds = 'twoSeconds',
    threeSeconds = 'threeSeconds',
    fourSeconds = 'fourSeconds',
}

export const StringFeatureToggleOptions = {
    p100AppBanner: AppBannerValues,
    p100AddToWishlistMobile: p100AddToWishlistMobileVariant,
    p100FiltersRedesign: p100FiltersRedesignVariant,
    p100AATest5: binaryWithNoExperiment,
    p100SimilarProductsSliderVariation: SimilarProductsSliderVariant,
    p100ABTestCalculatedVsPersonalizeCrossSalesRecommendations: BinaryWithOffVariant,
    p100ABTestControlVsTreatmentCrossSalesRecommendations: BinaryWithOffVariant,
    p100SsrJsonEscapingExperiment: p100SsrJsonEscapingExperimentVariant,
    p100PersonalizeCategoryPlpResults: BinaryWithOffVariant,
    p100ChangeSmartAppBannerLink: changeSmartAppBannerLink,
    p100EnableSlowDownTest: SlowDownTestDelayMilliseconds,
};

type StringFeatureToggles = Partial<{
    [P in keyof typeof StringFeatureToggleOptions]: keyof (typeof StringFeatureToggleOptions)[P];
}>;

export interface BooleanFeatureToggles {
    clubHeaderBarBanner?: boolean;
    clubLinkTabHighlight?: boolean;
    isBlackFridayActive?: boolean;
    isCyberMondayActive?: boolean;
    isDefaultCookieBannerEnabled?: boolean;
    isFacebookLoginDesktopEnabled?: boolean;
    isOneTrustCookieBannerEnabled?: boolean;
    isPdpTaxDisclaimerEnabled?: boolean;
    isNewTranslationModeEnabled?: boolean;
    isSpecialSalesEnabled?: boolean;
    isNativeVideoPlayerEnabled?: boolean;
    interiorServiceInNav?: boolean;
    showTranslation?: boolean;
    specialPrice?: boolean;
    shopForgotPasswordFlow?: boolean;

    // launch darkly
    p100PdpShowMoodImageFirst?: boolean;
    p100HotjarTracker?: boolean;
    shopAdditionalSkuSelector?: boolean;
    shopDeliveryTimePromise?: boolean;
    shopBellaCart?: boolean;
    shopBellaCheckout?: boolean;
    p100ImageOnHoverPlp?: boolean;
    p100UseRedisCache?: boolean;
    p100UsePDPCache?: boolean;
    p100PdpLooksSlider?: boolean;
    shopSegmentIntegration?: boolean;
    p100PdpThreeDImage?: boolean;
    p100ForceClubRegistrationPopup?: boolean;
    p100ForceClubRegistrationPopupForAffiliate?: boolean;
    p100SignalBoostSorting?: boolean;
    p100AlgoliaTest?: boolean;
    p100Plp120PerPage?: boolean;

    p100EnableInterleaving?: boolean;
    p100InterleaveByDefaultSortFirst?: boolean;
    p100PromotionalElementsLlp?: boolean;
    p100PlpLooksInfusion?: boolean;
    p100CISLPPosition?: boolean;
    shopSeoFilterValueUnderProductTitle?: boolean;
    p100WishlistCountServerSide?: boolean;
    p100QuantitySelector?: boolean;
    p100PlpInfusion?: boolean;
    p100LdpInfusion?: boolean;
    p100ShowS2CBanner?: boolean;
    p100BestSellerInfusion?: boolean;
    p100OnClickForceClubRegistrationPopup?: boolean;
    p100IsMunichUser?: boolean;
    p100WestwingDeliveryService?: boolean;
    p100RevisedMobileHeaderCategoryThumbnail?: boolean;
    p100RevisedMobileHeaderPromotionBar?: boolean;
    p100ColorVariantsPlp?: boolean;
    p100ColorVariantsPdp?: boolean;
    p100ShowColorVariantsPdp?: boolean;
    p100NewProductBadge?: boolean;
    p100PromoForStudio?: boolean;
    p100StudioSummerCampaign?: boolean;
    p100SaleNavigation?: boolean;
    p100RecentlyViewedPdp?: boolean;
    p100AssemblyServiceOverlay?: boolean;
    p100DeliveryTimesV2?: boolean;
    p100AssemblyServiceRecommendationBadge?: boolean;
    p100FourColumnPlp?: boolean;
    p100TwoManHandlingGallerySliderImage?: boolean;
    p100EnforceCloseButtonOnShop2ClubOverlay?: boolean;
    p100FreistellerImages?: boolean;
    p100PdpEnableKlarna?: boolean;
    p100EnableBrandsInNavigation?: boolean;
    p100EnableWoodDeclaration?: boolean;
    p100OnboardingTooltipForLoggedOutUsers?: boolean;
    p100ShippingFeesOverlay?: boolean;
    p100ClimateNeutralFootNote?: boolean;
    shopOrderLevelShipping?: boolean;
    shopOwwEmptyCartReminderEnabled?: boolean;
    shopSuccessPageRedesignEnabled?: boolean;
    p100DataPrefetchExperiment?: boolean;
    p100EnableNewOmnibusDirective?: boolean;
    p100UseNewCiLogo?: boolean;
    p100PlpVideo?: boolean;
    p100ReducedPdp?: boolean;
    p100CtaColorChange?: boolean;
    p100DragonFlyMvp?: boolean;

    // OWW Toggles
    p100OneWestwingSmallHeader?: boolean;
    shopOneCart?: boolean;
    isOwwHeaderSameBusinessOriginEnabled?: boolean;
    p100SmallMobileHeader?: boolean;

    // A/A Test toggles
    p100AATest1?: boolean;
    p100AATest2?: boolean;
    p100AATest3?: boolean;
    p100AATest4?: boolean;
    p100AATest6?: boolean;
    p100AATest7?: boolean;
    p100AATest8?: boolean;

    // query toggles
    skuDiver?: boolean;
    brazeReadyDebug?: boolean;

    // FeatureToggles for the Westwing  Studio AKA Interior Design Service MicroFrontend
    p100StudioPriceTiers?: boolean;

    p100WebBffEnabled?: boolean;
    p100WebBffHomepageEnabled?: boolean;
    shopSeoBreadcrumbsPdpMobile?: boolean;
    p100MobilePdpBreadcrumbAA?: boolean;

    p100EnablePtHreflang?: boolean;
}

export type FeatureToggles = BooleanFeatureToggles & StringFeatureToggles;
